import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Stack,
  Container,
} from "@mui/material";
import useConfirm from "../../../hooks/useConfirm";
import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { setUsers } from "../../../features/users/usersSlice";
import { Scrollbar } from "../components/scrollbar";
import { getAllUsers } from "../../../api/api";
import PuljeSelectorTabs from "../../../components/pulje-selector-tabs";
import ballLogo from "../../../assets/icons/ball-logo.png";
import { EVENT_TYPE } from "../../../types/types";

type PlayerSummary = {
  name: string;
  team: any; // or replace `any` with your Team type
  numberOfGoals: number;
};


export const Players = () => {
  const [Dialog, confirmDelete] = useConfirm(
    "Er du sikker?",
    `Er du sikker på at du vil slette denne bruger? Det er ikke muligt at fortryde dette valg, og der kan ikke oprettes en bruger med samme email igen.`
  );
  const dispatch = useAppDispatch();
  const matches = useAppSelector(state => state.matches.groupMatches);
  const selectedPuljeId = useAppSelector((state) => state.puljer.selectedPulje)?.id;

  useEffect(() => {
    getAllUsers().then((data) => {
      dispatch(setUsers(data));
    });
  }, []);

  const getPlayersFromGoals = useMemo(() => {

    const playerMap = new Map<string, PlayerSummary>();

    // Get all goal events from matches in the selected pulje
    const goalEvents = matches
      .filter(match => match.pulje.id === selectedPuljeId)
      .flatMap(match => [
        ...match.homeTeamEvents.filter(event => event.eventType === EVENT_TYPE.GOAL),
        ...match.awayTeamEvents.filter(event => event.eventType === EVENT_TYPE.GOAL)
      ]);

    for (const goalEvent of goalEvents) {
      if (!goalEvent.player) continue; // skip goals without player info

      const playerId = goalEvent.player.id;
      const existing = playerMap.get(playerId);

      if (existing) {
        existing.numberOfGoals += 1;
      } else {
        playerMap.set(playerId, {
          name: goalEvent.player.name,
          team: goalEvent.team,
          numberOfGoals: 1,
        });
      }
    }

    return Array.from(playerMap.values()).sort((a, b) => b.numberOfGoals - a.numberOfGoals);
  }, [selectedPuljeId, matches]);

  return (
    <>
      {Dialog()}
      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Topscore</Typography>
          </Stack>
          <PuljeSelectorTabs />
          <Card>
            <Scrollbar>
              <Box sx={{ minWidth: 300 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Navn</TableCell>
                      <TableCell>Hold</TableCell>
                      <TableCell>Antal mål</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {getPlayersFromGoals
                      .map((player, i) => {
                        return (
                          <TableRow hover key={player.name}>
                            <TableCell>{player.name}</TableCell>
                            <TableCell>
                              <Stack alignItems="center" direction="row" spacing={2}>
                                <img height={22} src={player.team?.club?.logo ?? ballLogo} />
                                <Typography variant="subtitle2">{player.team?.teamName}</Typography>
                              </Stack>
                            </TableCell>
                            <TableCell>{player.numberOfGoals}</TableCell>

                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Box>
            </Scrollbar>
          </Card>
        </Stack>
      </Container>
    </>
  );
};
